import { render, staticRenderFns } from "./addDictType.vue?vue&type=template&id=19c5858b&"
import script from "./addDictType.vue?vue&type=script&lang=js&"
export * from "./addDictType.vue?vue&type=script&lang=js&"
import style0 from "./addDictType.vue?vue&type=style&index=0&id=19c5858b&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports